import { exportStatusLabel, exportStatusVariant } from "@/domain/export/exportStatusUi";
import { CircleAlert, CircleCheck, Loader2 } from "lucide-react";
import type { ExportJobStatus } from "@/types/api";
import { cn } from "@/utils/cn";

const VARIANT_CLASS: Record<string, string> = {
  running: "chip chip-run",
  ready: "chip chip-ok",
  failed: "chip chip-fail",
  neutral: "chip",
};

export function ExportStatusBadge({ status }: { status: ExportJobStatus }) {
  const variant = exportStatusVariant(status);
  const icon =
    variant === "ready"
      ? <CircleCheck size={13} />
      : variant === "running"
        ? <Loader2 size={13} className="animate-spin" />
        : variant === "failed"
          ? <CircleAlert size={13} />
          : null;
  return (
    <span className={cn("inline-flex items-center gap-1", VARIANT_CLASS[variant] ?? "chip")}>
      {icon}
      {exportStatusLabel(status)}
    </span>
  );
}
